import { useEffect } from "react"

const useLiveWaitTimes = (setItems) => {
  useEffect(() => {
    const handler = (e) => {
      const entities = e.detail?.entities
      if (!Array.isArray(entities) || entities.length === 0) return

      const entityMap = Object.fromEntries(entities.map((entity) => [entity.name, entity]))

      setItems((prev) => {
        let changed = false
        const next = prev.map((item) => {
          const entity = entityMap[item.name]
          if (!entity) return item

          const isClosed = entity.status === "CLOSED" || entity.status === "DOWN"
          const newWait = isClosed ? null : (entity.wait_minutes ?? null)
          const newMeta = isClosed ? "Closed" : item.meta

          const oldWait = item.wait_minutes ?? null
          if (newWait === oldWait && newMeta === item.meta) return item
          changed = true
          return { ...item, wait_minutes: newWait, meta: newMeta }
        })
        return changed ? next : prev
      })
    }

    document.addEventListener("rodg-live-data-refresh", handler)
    return () => document.removeEventListener("rodg-live-data-refresh", handler)
  }, [setItems])
}

export default useLiveWaitTimes
